export default __webpack_public_path__ + "static/media/5393.37d3da33.png";